export const mockAchDiscountData = {
  achDiscountCode: 'D20P6M',
  achDiscountOverriden: false,
  achDiscountPeriodInMonths: 6,
  achDiscountedPercentage: 0.8,
};
